/*
 * @Author: chenhan 13289208928@163.com
 * @Date: 2025-05-07 10:01:27
 * @LastEditors: chenhan 13289208928@163.com
 * @LastEditTime: 2025-05-07 14:03:45
 * @FilePath: /file-view-master/src/index.js
 * @Description: 
 */
import KnFilePreview from './components/KnFilePreview.vue';

const install = function (app) {
    app.component(KnFilePreview.name, KnFilePreview);
};

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    install,
    KnFilePreview
};